module.exports = __webpack_public_path__ + "static/media/Informationicon03.c9bee616.png";